/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Card, Button, Modal } from 'react-bootstrap';
import {
  AnalyticsWidget,
  IAnalyticsLayoutProps,
} from '../../../../widgets/analytics-widget-react';
import { ApexChartWidget } from '../../../../widgets/charts-widget';
import {
  chartOptions,
  tropicalCycloneAnnotationPointsTemplate,
  payoutElibileAnnotationsTemplate,
} from './config/chart.config';

export interface IWeatherAnalytics {
  showModal?: boolean;
  modalTitle?: string;
  chartSeries?: {
    yaxisLabel: string;
    data: number[];
    labels: string[];
    tropicalCyclones?: {
      x: string;
      y: number;
      category: string;
    }[];
    eligiblePayouts?: { x: string; message: string }[];
  };
  tableData?: IUserListCompProps;
  onDeny?(): void;
}

export const WeatherAnalytics = (props: IWeatherAnalytics) => {
  const { chartSeries, tableData } = props;
  const options = { ...chartOptions };
  if (chartSeries?.labels) {
    options.xaxis.categories = chartSeries?.labels;
  }
  if (chartSeries?.tropicalCyclones) {
    for (const tc of chartSeries?.tropicalCyclones) {
      const tcTemplate = { ...tropicalCycloneAnnotationPointsTemplate };
      tcTemplate.x = tc.x;
      tcTemplate.y = tc.y;
      tcTemplate.label = { ...tcTemplate.label, text: tc.category };
      options.annotations.points.push(tcTemplate);
    }
  }
  if (chartSeries?.eligiblePayouts) {
    for (const ep of chartSeries?.eligiblePayouts) {
      const epTemplate = { ...payoutElibileAnnotationsTemplate };
      epTemplate.x = ep.x;
      epTemplate.label = { ...epTemplate.label, text: ep.message };
      options.annotations.xaxis.push(epTemplate);
    }
  }

  const _chartSeries = [
    {
      name: chartSeries?.yaxisLabel,
      data: chartSeries.data,
    },
  ];
  return (
    <Card border="light" className="px-0 px-md-4 py-0 border-0">
      <Card.Body>
        <ApexChartWidget
          type={'area'}
          chartOptions={options}
          chartSeries={_chartSeries}
        />
      </Card.Body>
    </Card>
  );
};
